<template>
      <div class="mobile-app-area">
        <div class="container">
            <div class="row align-items-center right-side-flex">
                <div class="col-lg-6 col-md-12">
                    <div class="about-content"><span class="sub-title text-uppercase">AI-Enabled</span>
                        <h2>Custom AI-Enabled Development Services</h2>
                        <p> We create tailor-made software solutions from web platforms to enterprise systems — with
                            AI built in for decision support, real-time analytics, and adaptive functionality. Your
                            software grows with your business needs.</p>
                        <div class="features-text">
                            <h6>Industries</h6>
                            <p>Enterprise, logistics, healthcare, fintech, government, and more.
                            </p>
                            <h6> Key Benefits</h6>
                            <p>Scalable architecture, AI insights, competitive edge, long-term adaptability.
                            </p>
                             <h6>Technologies</h6> 
                            <p> Python, Django, Laravel, React, Angular, PyTorch, TensorFlow, Azure AI Services.
                            </p>
                            <a href="/contact" class="nav-link" style="padding: 0;"><button class="default-btn">Contact Us</button></a>
                        </div>

                        <!-- <div class="btn-box"><a href="/jexa/contact" class="default-btn">Start Free Trial</a><a
                            href="/jexa/features-one" class="link-btn">See All Features</a></div> -->
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="about-img">
                        <img src="../../assets/images/ready-launch01.png" data-aos="fade-up" alt="launch app"
                            class="aos-init aos-animate">
                    </div>
                </div>



            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "CustomAi",
};
</script>